import ReactDOMServer from "react-dom/server";
import React from "react";
import { createRegex } from "Utils/createRegex";

const markStyle = { padding: "0", margin: "0" };
export const highlightText = (item, keyword) => {
  const re = createRegex({ text: keyword || "", flags: "gi" });
  return item.replace(re, val =>
    ReactDOMServer.renderToStaticMarkup(<mark style={markStyle}>{val}</mark>)
  );
};

const AnchorTagRegex = /<a[^>]*>(.*?)<\/a>/gi;

export const highlightTextOutsideAnchorTag = ({
  item,
  keyword,
  getHighlightJSX = val => <mark>{val}</mark>,
}) => {
  const re = createRegex({ text: keyword || "", flags: "gi" });
  const combinedOrRegex = new RegExp(
    `${AnchorTagRegex.source}|${re.source}`,
    "gi"
  );
  return item.replace(combinedOrRegex, val => {
    // In case of anchor tag, we don't want to highlight the text here
    // as it will break the href attribute.
    if (val.match(AnchorTagRegex)) return val;
    return ReactDOMServer.renderToStaticMarkup(getHighlightJSX(val));
  });
};

const HtmlTagWithContentRegex = /<[^>]*>(.*?)<\/[^>]*>|<\/[^>]*>/gi;

export const highlightTextOutsideRegex = ({
  item,
  keyword,
  regex = HtmlTagWithContentRegex,
  getHighlightJSX = val => <mark>{val}</mark>,
}) => {
  const re = createRegex({ text: keyword || "", flags: "gi" });
  const combinedOrRegex = new RegExp(`${regex.source}|${re.source}`, "gi");
  return item.replace(combinedOrRegex, val => {
    // In case of regex, we don't want to highlight the text here
    // as it will break the attribute.
    if (val.match(regex)) return val;
    return ReactDOMServer.renderToStaticMarkup(getHighlightJSX(val));
  });
};

const defaultStyle = { fontWeight: "bold" };

export const highlightTextWithCustomStyle = (
  item,
  keyword,
  style = defaultStyle
) => {
  const re = createRegex({ text: keyword || "", flags: "gi" });
  return item.replace(re, val =>
    ReactDOMServer.renderToStaticMarkup(<span style={style}>{val}</span>)
  );
};
